import React, { useEffect, useState } from 'react';
import { Carousel, Container, Image, Placeholder } from 'react-bootstrap';

export default function DynamicSlider({ stId }) {
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const [isLoading, setLoading] = useState(true);
    const [hpSlider, setSlider] = useState([]);

    useEffect(() => {
        const getSlider = async () => {
            try {
                
                const response = await fetch(global.config.API_URL + "slider/byType/" + stId);
                const result = await response.json();
                if (result.length > 0) {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {
                        allResponse.forEach((el, i) => {
                            result[i].slideImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].slideImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setSlider(result);
                    }).catch(error => {
                        console.error('Slider File:', error);
                    });
                }
                if (global.config.IsPrint === true) { console.info('Slider : Result', result); }
            } catch (error) {
                console.error('Slider : Error', error.message);
            } finally {
                setLoading(false);
            }
        };
        getSlider();
    }, [stId]);

    return (
        <Container fluid className="p-0">
            {isLoading ? (
                <Carousel id="carouselHero" data-bs-theme="dark" aria-label="Loading carousel">
                    {[...Array(5)].map((_, index) => (
                        <Carousel.Item key={index}>
                            <Placeholder xs={12} className="d-block w-100" bg="light" style={{ height: "400px" }} />
                        </Carousel.Item>
                    ))}
                </Carousel>
            ) : (
                <Carousel id="carouselHero" data-bs-theme="dark" aria-label="Image carousel">
                    {hpSlider.slice(0, 20).map((hs, index) => (
                        <Carousel.Item key={index}>
                            {appLanguage === 'hi' ? (
                                hs.ss_display_en === "1" && hs.slideImageHi ? (
                                    <Image
                                        src={hs.slideImageHi}
                                        fluid
                                        width={1400}
                                        height={440}
                                        alt={hs.ss_name_hi || hs.ss_name}
                                        loading="lazy"
                                    />
                                ) : hs.slideImageHi ? (
                                    <Image
                                        src={hs.slideImageHi}
                                        fluid
                                        width={1400}
                                        height={440}
                                        alt={hs.ss_name_hi || hs.ss_name}
                                        loading="lazy"
                                    />
                                ) : hs.slideImage ? (
                                    <Image
                                        src={hs.slideImage}
                                        fluid
                                        width={1400}
                                        height={440}
                                        alt={hs.ss_name_hi || hs.ss_name}
                                        loading="lazy"
                                    />
                                ) : null
                            ) : (
                                hs.slideImage ? (
                                    <Image
                                        src={hs.slideImage}
                                        fluid
                                        width={1400}
                                        height={440}
                                        alt={hs.ss_name}
                                        loading="lazy"
                                    />
                                ) : null
                            )}
                        </Carousel.Item>
                    ))}
                </Carousel>
            )}
        </Container>
    );
}